import type {RefObject} from 'react';
import {createContext, useContext} from 'react';

export interface TimelineRefsContextValue {
  scrollContainerRef: RefObject<HTMLDivElement | null>;
  seekIndicatorRef: RefObject<HTMLDivElement | null>;
  hoverLineRef: RefObject<HTMLDivElement | null>;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const TimelineRefsContext = createContext<TimelineRefsContextValue | null>(null);

export function useTimelineRefs(): TimelineRefsContextValue {
  const context = useContext(TimelineRefsContext);
  if (!context) {
    throw new Error('useTimelineRefs must be used within a TimelineRefsProvider');
  }
  return context;
}

export function useTimelineScrollContainerRef(): RefObject<HTMLDivElement | null> {
  const {scrollContainerRef} = useTimelineRefs();
  return scrollContainerRef;
}

export function useTimelineSeekIndicatorRef(): RefObject<HTMLDivElement | null> {
  const {seekIndicatorRef} = useTimelineRefs();
  return seekIndicatorRef;
}

export function useTimelineHoverLineRef(): RefObject<HTMLDivElement | null> {
  const {hoverLineRef} = useTimelineRefs();
  return hoverLineRef;
}
